

const ButtonSimp = ({
  margin = "2",
  size = "md",
  font = "6",
  color = "primary",
  padding = "0",
  paddingtop ,
  paddingstart ,
  paddingend ,
  paddingbottom ,
  text = "Click Me",
  className = "",
  children,
  clicked,
}) => {
  return (
    <>
      <button
        type="button"
        className={`m-${margin} 
        btn position-relative
        shadow
        fs-${font}
         btn-${size}
         btn-${color}
       p-${padding} pt-${paddingtop} pb-${paddingbottom} ps-${paddingstart} pe-${paddingend}  ${className}`}
        onClick={clicked}
      >
        {children}
        {text}
      </button>
    </>
  );
};

export default ButtonSimp;
//  <ButtonSimp
//           margin="2"
//           size="md"
//           font="6"
//           color="danger"
//           padding="2"
//           paddingtop="1"
//           text="Cancel"
//           clicked={onClose}
//         />
